"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = exports.DefaultSelectChildren = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
const CurrentSelection_1 = require("./CurrentSelection");
const Option_1 = require("./Option");
const Menu_1 = require("../Menu");
const Paragraph_1 = require("../Paragraph");
const Menu_2 = require("./Menu");
function DefaultSelectChildren({ current, }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [current && ((0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { children: current.label })), !current && ((0, jsx_runtime_1.jsx)(Paragraph_1.Paragraph, { children: "No Selection" }))] }));
}
exports.DefaultSelectChildren = DefaultSelectChildren;
function Select({ Option = Option_1.DefaultOption, children = DefaultSelectChildren, onChange, options, value, }) {
    // Determine the currently selected option.
    const current = react_1.default.useMemo(() => {
        return R.find(R.propEq('value', value), options);
    }, [options, value]);
    // Generate props for select children.
    const props = react_1.default.useMemo(() => {
        return {
            current,
        };
    }, [current]);
    // Fired when an option is clicked.
    const onClickOption = react_1.default.useCallback(({ option, close, }) => {
        onChange(option.value);
        close();
    }, [onChange]);
    return ((0, jsx_runtime_1.jsx)(Menu_1.Menu.Flyout, Object.assign({ content: ({ close }) => ((0, jsx_runtime_1.jsx)(Menu_2.SelectMenu, { Option: Option, onClick: (option) => onClickOption({ option, close }), isSelected: (value, option) => value === option.value, options: options, value: value })) }, { children: ({ toggle }) => {
            return ((0, jsx_runtime_1.jsx)(CurrentSelection_1.CurrentSelection, Object.assign({ onClick: toggle }, { children: children(props) })));
        } })));
}
exports.Select = Select;
